import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import appServices from "../../services/app-services/appServices";

type Block = {
  id: number;
  blocked_id: number;
  user_id: number;
  blocked_type: "User" | "MemberGroup";
}

type State = {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  blocks: Block[]
}

export const initialState: State = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  blocks: [],
}

export const getBlocks = createAsyncThunk(
  "blocks",
  async (userId: number, thunkAPI: any) => {
    try {
      return await appServices.getBlocks({user_id: userId})
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const blocksReducer = createSlice({
  name: "blocks",
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBlocks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBlocks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.blocks = action.payload.blocks;
      })
      .addCase(getBlocks.rejected, (state: any, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const { reset } = blocksReducer.actions;
export default blocksReducer.reducer;
